import { InvoiceData } from "../../types/type";

export default function SenderInfo({ invoiceData }: { invoiceData: InvoiceData }) {
    return (
        <div className="bg-white p-4 rounded-lg shadow-sm">
            <h2 className="text-md font-medium text-gray-800 mb-3">Sender Information</h2>
            <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                    <span className="text-gray-600">Name:</span>
                    <span className="whitespace-normal text-right font-medium">{invoiceData.sender.name}</span>
                </div>
                {
                    invoiceData.sender.email &&
                    <div className="flex justify-between">
                        <span className="text-gray-600">Email:</span>
                        <span className="whitespace-normal text-right font-medium">{invoiceData.sender.email}</span>
                    </div>
                }

            </div>
        </div>
    )
}